export class EditImage {
  jobId: string;
  file: any;
  comment: string;
  isAfter: boolean;
}
export class EditImageResponse {
  name: string;
  url: string;
  message: string;
}
